var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7454 0C18.988 0 19.9954 1.00736 19.9954 2.25V11.7546C19.9954 12.9972 18.988 14.0046 17.7454 14.0046H2.25C1.00736 14.0046 0 12.9972 0 11.7546V2.25C0 1.00736 1.00736 0 2.25 0H17.7454ZM15.25 9.5H4.75L4.64823 9.50685C4.28215 9.55651 4 9.8703 4 10.25C4 10.6297 4.28215 10.9435 4.64823 10.9932L4.75 11H15.25L15.3518 10.9932C15.7178 10.9435 16 10.6297 16 10.25C16 9.8703 15.7178 9.55651 15.3518 9.50685L15.25 9.5ZM14.5 6C13.9477 6 13.5 6.44772 13.5 7C13.5 7.55228 13.9477 8 14.5 8C15.0523 8 15.5 7.55228 15.5 7C15.5 6.44772 15.0523 6 14.5 6ZM11.5049 6C10.9526 6 10.5049 6.44772 10.5049 7C10.5049 7.55228 10.9526 8 11.5049 8C12.0572 8 12.5049 7.55228 12.5049 7C12.5049 6.44772 12.0572 6 11.5049 6ZM8.50488 6C7.95259 6 7.50488 6.44772 7.50488 7C7.50488 7.55228 7.95259 8 8.50488 8C9.05716 8 9.50488 7.55228 9.50488 7C9.50488 6.44772 9.05716 6 8.50488 6ZM5.50488 6C4.95259 6 4.50488 6.44772 4.50488 7C4.50488 7.55228 4.95259 8 5.50488 8C6.05716 8 6.50488 7.55228 6.50488 7C6.50488 6.44772 6.05716 6 5.50488 6ZM4 3C3.44772 3 3 3.44772 3 4C3 4.55228 3.44772 5 4 5C4.55228 5 5 4.55228 5 4C5 3.44772 4.55228 3 4 3ZM6.99512 3C6.44284 3 5.99512 3.44772 5.99512 4C5.99512 4.55228 6.44284 5 6.99512 5C7.54741 5 7.99512 4.55228 7.99512 4C7.99512 3.44772 7.54741 3 6.99512 3ZM9.99512 3C9.44284 3 8.99512 3.44772 8.99512 4C8.99512 4.55228 9.44284 5 9.99512 5C10.5474 5 10.9951 4.55228 10.9951 4C10.9951 3.44772 10.5474 3 9.99512 3ZM12.9951 3C12.4428 3 11.9951 3.44772 11.9951 4C11.9951 4.55228 12.4428 5 12.9951 5C13.5474 5 13.9951 4.55228 13.9951 4C13.9951 3.44772 13.5474 3 12.9951 3ZM15.9951 3C15.4428 3 14.9951 3.44772 14.9951 4C14.9951 4.55228 15.4428 5 15.9951 5C16.5474 5 16.9951 4.55228 16.9951 4C16.9951 3.44772 16.5474 3 15.9951 3Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_1267",
    x1: 9.99768,
    y1: 0,
    x2: 9.99768,
    y2: 14.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9DAA",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.470397288e9c2bbf929a84d2dc6c6087.svg";
export { ForwardRef as ReactComponent };